import { render, staticRenderFns } from "./PostCreation_Modal_Text.vue?vue&type=template&id=507cdea2&"
import script from "./PostCreation_Modal_Text.vue?vue&type=script&lang=js&"
export * from "./PostCreation_Modal_Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports